export default "__VITE_ASSET__Dlh8BhiW__"